import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hods',
  templateUrl: './hods.component.html',
  styleUrls: ['./hods.component.scss']
})
export class HodsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
